import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import { LoadingStatusType } from "@/enums/enums";

@Module({ namespaced: true })
class Breadcrumb extends VuexModule {
  public breadcrumb: Array<any> = [];

  @Mutation
  public MutationAddBreadcrumb(input: any) {
    this.breadcrumb.push(input);
  }

  @Mutation
  public MutationResetBreadcrumb() {
    this.breadcrumb = [];
  }

  @Action
  public AddBreadcrumb(input: any) {
    this.context.commit("MutationAddBreadcrumb", input);
  }
  @Action
  public ResetBreadcrumb() {
    this.context.commit("MutationResetBreadcrumb");
  }

  get getBreadcrumb(): Array<any> {
    return this.breadcrumb;
  }
}

export default Breadcrumb;
